import styles from './LoginPage.module.css';
import { connect } from 'react-redux';
import { MainLoginForm, ResetDefaultPasswordForm } from '../../components/LoginForms';
import { SelectLanguage } from '../../components/SelectLanguage/SelectLanguage';

const LoginPageComponent = ({ loginForm }) => (
    <div className={styles.loginPage}>
        <div className={styles.loginHeader}>
            <SelectLanguage />
        </div>
        <div className={styles.loginWrapper}>
            <div>
                <h1>Whoosh Martin</h1>
                {
                    loginForm.isPasswordResetRequired
                        ? <ResetDefaultPasswordForm />
                        : <MainLoginForm />
                }
            </div>
        </div>
    </div>
);
const mapStateToProps = ({ loginForm }) => ({ loginForm });
export const LoginPage = connect(mapStateToProps)(LoginPageComponent);
